import {
  Box,
  Grid,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import AppBarCustom from "../component/AppBar";
import styled from "@emotion/styled";
import { InfoRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),

  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export default function DashboardPage(params) {
  const theme = useTheme();
  const goTo =useNavigate() 

  const CardCustom = (item) => {
    return(
      <Box padding={2} bgcolor={"white"} border={"1px solid grey"} boxShadow={2} borderRadius={4}>
        <Stack direction={"column"} alignItems={"start"}>
          <Stack
            width={"100%"}
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography variant="body1" align="center" fontWeight={"bold"}>
              {item.title}
            </Typography>
            <IconButton onClick={(e)=>
              goTo(item.title)
            }>
              <InfoRounded />
            </IconButton>
          </Stack>
          <Stack direction={"row"} spacing={2} alignItems={"end"}>
            <Typography variant="h2" fontWeight={"bold"}>{item.data}</Typography>
            <Typography variant="h6"> {item.satuan}</Typography>
          </Stack>
        </Stack>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        minHeight:"100vh",
        padding: 0,
        bgcolor: "#E1E1E1",
      }}
    >
      <AppBarCustom selected="Dashboard" />
      {/* <Toolbar sx={{ padding: 10 }} /> */}

      <Box component="main" sx={{ flexGrow: 1, p: 3}}>
        <DrawerHeader theme={theme} />
        <Typography variant="h4" sx={{ fontWeight: "bold", marginBottom: 2 }} align="left">
          Selamat Datang, {localStorage.getItem("name")}!
        </Typography>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 3 }}>
            <CardCustom title={"Potensi"} data={params.data.potensi} satuan={"titik"}/>
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <CardCustom title={"Peluang"} data={params.data.peluang} satuan={"titik"}/>
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <CardCustom title={"Infrastruktur"} data={params.data.infrastruktur} satuan={"titik"}/>
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <CardCustom title={"Pengguna"} data={params.data.pengguna} satuan={"Pengguna"}/>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
